import React from 'react';
import clsx from 'clsx';
import styles from './Textarea.module.scss';
import {
  warnOnDisallowedProps,
  normalizeVariant,
} from '../../../designSystemGuards';

const COMPONENT_NAME = 'Textarea';

const ALLOWED_VARIANTS = ['default', 'error'];
const DISALLOWED_PROPS = [
  'size',
  'fullWidth',
  'width',
  'margin',
  'padding',
  'hasError',
  'isInvalid',
];

const DEFAULT_ROWS = 3;

/**
 * Textarea
 *
 * Primitive multi-line text input.
 * - Semantic control only (no layout)
 * - Size inherited from context
 * - All native <textarea> attributes supported
 */
const Textarea = (props) => {
  warnOnDisallowedProps(
    COMPONENT_NAME,
    props,
    DISALLOWED_PROPS
  );

  const {
    variant: rawVariant,
    className,
    rows = DEFAULT_ROWS,
    ...nativeProps
  } = props;

  const variant = normalizeVariant(
    COMPONENT_NAME,
    rawVariant,
    ALLOWED_VARIANTS,
    'default'
  );

  return (
    <span
      className={clsx(
        styles.textarea,
        styles[`variant-${variant}`],
        className
      )}
    >
      <textarea
        rows={rows}
        {...nativeProps}
      />
    </span>
  );
};

export default Textarea;
